import { create } from "zustand";

export const useDatGuiStore = create((set, get) => ({
  onUpdate: newData => set(prevState => ({
    data: { ...prevState.data, ...newData }
  })),
  data: {
    duration: 1000,
    easing: 'easeInQuad',
    easings: [
      'easeInQuad',
      'easeInCubic',
      'easeInQuart',
      'easeInQuint',
      'easeInSine',
      'easeInExpo',
      'easeInCirc',
      'easeInBack',
      'easeOutQuad',
      'easeOutCubic',
      'easeOutQuart',
      'easeOutQuint',
      'easeOutSine',
      'easeOutExpo',
      'easeOutCirc',
      'easeOutBack',
      'easeInBounce',
      'easeInOutQuad',
      'easeInOutCubic',
      'easeInOutQuart',
      'easeInOutQuint',
      'easeInOutSine',
      'easeInOutExpo',
      'easeInOutCirc',
      'easeInOutBack',
      'easeInOutBounce',
      'easeOutBounce',
      'easeOutInQuad',
      'easeOutInCubic',
      'easeOutInQuart',
      'easeOutInQuint',
      'easeOutInSine',
      'easeOutInExpo',
      'easeOutInCirc',
      'easeOutInBack',
      'easeOutInBounce',
    ]
  },
}));